export const TextShow = ({title, icon, exp, justText, breaksm, data, className, className2, className3}) => {
    return (
        <div className={`text-show ${breaksm ? 'break-sm' : ''}`}>
            <div className='flex-row-center-center'>
                {icon}
                {
                    title &&
                    <p className={`info-text text-nowrap ${className ? className : ''} ${icon ? 'me-2' : ''}`}>{title}</p>
                }
            </div>
            {
                !justText &&
                <div className="flex-column-start-start">
                    <p className={`${className2 ? className2 : ''} ${data ? '' : 'text-muted small'}`}>
                        {data ? data : `${title.toString().replace(':','').trim()} ثبت نشده است`}
                    </p>
                </div>
            }
            { exp && <small className={className3}>{`(${exp})`}</small> }
        </div>
    )
}